<template>
  <div
    v-if="hasDescription()"
    @click.stop="$emit('infoIconClicked')"
    class="infoIcon"
  >
    i
  </div>
</template>

<script>
import { getTranslation } from "@/utils/helpers";
import { isEmpty } from "lodash";

export default {
  name: "InfoIcon",
  props: {
    product: Object
  },
  methods: {
    hasDescription() {
      if (!this.product) {
        return false;
      }
      let description = getTranslation(
        this.$store,
        "Product",
        "description",
        this.product.id,
        ""
      );
      console.log("description " + description);
      return !isEmpty(description);
    }
  }
};
</script>

<style lang="scss" scoped>
.infoIcon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--component_common_InfoIcon_background);
  border-radius: 100%;
  font-size: 18px;
  font-family: var(--component_common_InfoIcon_font-family);
  color: var(--component_common_InfoIcon_color);
}
</style>
